/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { useHistory, useParams } from 'react-router-dom';
import { Button } from 'reactstrap';
import { generateUrl } from '../../routes/util';
import { ROUTES } from '../../constants/routes';
import { NavCode } from '../survey-templates/types';

export const TemplateHistoryHeader = ({ page = NavCode.History }) => {
  const { initiativeId = '', templateId = '' } = useParams<{ initiativeId: string, templateId: string }>();
  const history = useHistory();
  const goBack = () => {
      history.push(`${generateUrl(ROUTES.SURVEY_TEMPLATES_VIEW, {
        initiativeId,
        templateId,
        page: page ?? NavCode.History
      })}`);
  };
  return (
    <div className='w-100 ml-3 mb-4'>
      <Button color='link' onClick={goBack}>
        <i className='fa fa-arrow-circle-left mr-2' />
        Go back to template dashboard
      </Button>
    </div>
  );
};
